import Icon from '../components/Icon.vue'

Icon.register({
  scroll: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M48 0C21.5 0 0 21.5 0 48V112C0 120.8 7.2 128 16 128H96V48C96 21.5 74.5 0 48 0zM256 412.6V352H544V96C544 43.1 500.9 0 448 0H111.6C121.7 13.4 128 29.9 128 48V416C128 454.9 162.7 485.6 202.8 479.1 234.2 474 256 444.5 256 412.6zM288 384V416C288 468.9 244.9 512 192 512H528C589.9 512 640 461.9 640 400 640 391.2 632.8 384 624 384H288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/scroll.js
// module id = VvaV
// module chunks = 144